var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgHomeSelected = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/home-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5402 6.82018L14.7802 2.79018C13.2102 1.69018 10.8002 1.75018 9.29023 2.92018L4.28023 6.83018C3.28023 7.61018 2.49023 9.21018 2.49023 10.4702V17.3702C2.49023 19.9202 4.56023 22.0002 7.11023 22.0002H17.8902C20.4402 22.0002 22.5102 19.9302 22.5102 17.3802V10.6002C22.5102 9.25018 21.6402 7.59018 20.5402 6.82018ZM13.2502 18.0002C13.2502 18.4102 12.9102 18.7502 12.5002 18.7502C12.0902 18.7502 11.7502 18.4102 11.7502 18.0002V15.0002C11.7502 14.5902 12.0902 14.2502 12.5002 14.2502C12.9102 14.2502 13.2502 14.5902 13.2502 15.0002V18.0002Z",
    fill: "#263349"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHomeSelected, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/home-selected.c841afad.svg";
export { ForwardRef as ReactComponent };